import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

// Map route -> preload assets
const assetsByRoute = {
  "/aa1": (lang) => ({
    css: ["/Aa1HomePageStyle.css"],
    images: [
      { href: "/kid-security-logo-en.avif", priority: "high" },
      { href: "/download-icon.avif", priority: "high" },
    ]
  }),

  "/aa2": (lang) => ({
    css: ["/Aa2HomePageStyle.css"],
    images: [
      { href: "/kid-security-logo-en.avif", priority: "high" },
      { href: "/phone-icon.avif", priority: "high" },
      { href: "/phone-logo.avif", priority: "high" },
    ]
  }),

  "/aa3": (lang) => ({
    css: ["/Aa3HomePageStyle.css"],
    images: [
      { href: "/kid-security-logo-en.avif", priority: "high" },
      { href: "/phone-icon.avif", priority: "high" },
      { href: "/phone-logo.avif", priority: "high" },
    ]
  }),

  "/aa4": (lang) => ({
    css: ["/Aa4HomePageStyle.css"],
    images: [
      { href: "/kid-security.avif", priority: "high" },
      { href: "/kid-security-logo-en.avif", priority: "high" },
      { href: "/kid-security-logo-ar.avif", priority: "high" },
    ]
  }),

  "/aa4523": (lang) => ({
    css: ["/PinPageStyle.css"],
    images: [
      { href: "/frame.avif", priority: "high" },
      { href: "/play.avif", priority: "high" },
      { href: "/phone.avif", priority: "high" },
      { href: "/kid-en.avif", priority: "high" },
      { href: "/kid-ar.avif", priority: "high" },
    ]
  }),

  "/aa2208": (lang) => ({
    css: ["/Page2208Style.css"],
    images: [
      { href: "/download-file.avif", priority: "high" },
      { href: "/kid-security.avif", priority: "high" },
      { href: "/parent-1.avif", priority: "high" },
      { href: "/parent-2.avif", priority: "high" },
      { href: "/parent-3.avif", priority: "high" },
      { href: "/parent-4.avif", priority: "high" },
      { href: "/kid-security-logo-en.avif", priority: "high" },
      { href: "/kid-security-logo-ar.avif", priority: "high" },
    ]
  }),

  "/aa3346": (lang) => ({
    css: ["/Page3346Style.css"],
    images: [
      { href: "/tick.avif", priority: "high" },
    ]
  }),

  "/aa000": (lang) => ({
    css: ["/Aa000HomePageStyle.css"],
    images: [
      { href: "/phone-icon.avif", priority: "high" },
      { href: "/phone-logo.avif", priority: "high" },
      { href: "/kid-security-logo-en.avif", priority: "high" },
    ]
  }),
};

// Decide language (adjust to your app logic)
function detectLang() {
  // Option 1: from URL query ?lang=ar
  const params = new URLSearchParams(window.location.search);
  const lang = (params.get("lang") || "").toLowerCase();
  if (lang === "ar" || lang === "en") return lang;

  // Option 2: from browser
  return (navigator.language || "en").toLowerCase().startsWith("ar") ? "ar" : "en";
}

export default function LpPreloads() {
  const { pathname } = useLocation();
  const lang = detectLang();

  // Generic result pages (ResultPage) are self-styled; don't load an LP's CSS on them.
  if (/\/failed$/.test(pathname) || /^\/(aa1|aa2|aa4)\/success$/.test(pathname)) return null;

  // match exact route only (ignore /success, /terms)
  const getAssets = assetsByRoute[pathname] || assetsByRoute[pathname.replace(/\/(success|terms)$/, "")];

  const { css = [], images = [] } = getAssets ? getAssets(lang) : {};

  if (!css.length && !images.length) return null;

  return (
    <Helmet>
      {/* Load CSS */}
      {css.map((href) => (
        <link key={href} rel="stylesheet" href={href} />
      ))}

      {/* Images preload */}
      {images.map((a) => (
        <link
          key={a.href}
          rel="preload"
          as="image"
          href={a.href}
          fetchPriority={a.priority}
        />
      ))}
    </Helmet>
  );
}
